import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import { FaEnvelope } from "react-icons/fa"

const contact = () => {
  return (
    <Layout>
      <SEO title="Contact" description="rafael hernandez contact page" />
      <section className="contact-page">
        <div style={{ display: "flex" }}>
          <FaEnvelope className="social-icon" />
          <h4 style={{ marginLeft: "10px" }}>
            <span style={{ fontWeight: "400" }}>
              Email: rafaelHernandez@berkeley.edu
            </span>
          </h4>
        </div>
        <article className="contact-form">
          <h3>get in touch</h3>
          <form>
            <div className="form-group">
              <input type="text" placeholder="name" className="form-control" />
              <input
                type="email"
                placeholder="email"
                className="form-control"
              />
              <textarea
                name="mesasge"
                rows="5"
                placeholder="message"
                className="form-control"
              />
            </div>
            <button type="submit" className="submit-btn btn">
              submit here
            </button>
          </form>
        </article>
      </section>
    </Layout>
  )
}

export default contact
